import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useGetCart } from '../../../hooks/use-get-cart.js';
import { Title } from '../components/Title.js';

const TitleContainer = ()=>{
    const intl = useIntl();
    const { data  } = useGetCart();
    var _numberOfItems;
    const numberOfItems = (_numberOfItems = data === null || data === void 0 ? void 0 : data.getCart.cart.numberOfItems) !== null && _numberOfItems !== void 0 ? _numberOfItems : 0;
    const value = React.useMemo(()=>{
        return Util.getCartTotalsTitle(numberOfItems, intl, 'cart.minicart.totalsTitle.singular', 'cart.minicart.totalsTitle');
    }, [
        numberOfItems,
        intl
    ]);
    return /*#__PURE__*/ React.createElement(Title, {
        value: value
    });
};

export { TitleContainer };
//# sourceMappingURL=TitleContainer.js.map
